import axios from '@/utils/request'
var Qs = require('qs')

export default {
	// 2021-01-05
	search(params) {
		return axios.get('/mms/inventories-snapshoot', params);
	},
	// 2021-01-05
	detailsSearch(params) {
		return axios.get('/mms/inventories-snapshoot/details-search', params);
	},
	// 2021-01-05
	quickPhotoExportExcel(params) {
		return axios.get('/mms/inventories-snapshoot/quick-photo-export-excel?' + Qs.stringify(params, { arrayFormat: 'repeat' }));
	}

}

